import { updateFormGroup } from "../graphql/mutations";
import { generateClient } from "aws-amplify/api";
import { recordSentry } from "./recordSentry";

async function updateFormGroupNameAmplify(data: { id: string; name: string; group: string; updatedAt: string }) {
	try {
		const client = generateClient({ authMode: "userPool" });
		await client.graphql({
			query: updateFormGroup,
			variables: {
				input: data,
			},
			authMode: "userPool",
		});
	} catch (err) {
		recordSentry({ error: err, msg: "Error updating form group:", showModal: true });
	}
}

export default updateFormGroupNameAmplify;
